// src/api/axiosInstance.ts
import axios from "axios";
import { RootState, store } from "../store";

const axiosInstance = axios.create({
  baseURL: process.env.REACT_APP_API_BASE_URL,
  headers: { "Content-Type": "application/json" },
  withCredentials: true,
});

// Attach interceptors
axiosInstance.interceptors.request.use((config) => {
  const state: RootState = store.getState();

  const token = state.Auth?.token_details?.accessToken
    ? state.Auth?.token_details?.accessToken
    : localStorage.getItem("tobacco_access_token");

  // Allow auth flows that need to use a temporary token for one request
  // (for example, exchanging an Okta token for the CMS token).
  if (token && config.headers && !config.headers.Authorization) {
    config.headers.Authorization = `Bearer ${token}`;
  }

  return config;
});

axiosInstance.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response?.status === 401) {
      const oktaAuthenticated = sessionStorage.getItem("okta_authenticated");

      if (oktaAuthenticated !== "true") {
        window.location.href = "/login";
      }
    }

    return Promise.reject(error);
  },
);

const createApiCall = () => axiosInstance;

export default createApiCall;
